import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/uxp-photoshop-zh-cn/uxp-photoshop-zh-cn/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "footer"
    }}>{`footer`}</h1>
    <p><strong parentName="p">{`Since:`}</strong>{` UXP v3.0`}</p>
    <p>{`The `}<inlineCode parentName="p">{`<footer>`}</inlineCode>{` element is used in dialogs to help align buttons to the right-side of a dialog. You aren't required to use this element, and you can override any styles if you so choose.`}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en/docs/Web/HTML/Element/footer"
      }}>{`https://developer.mozilla.org/en/docs/Web/HTML/Element/footer`}</a></p>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<dialog>
    <form method="dialog">
        <sp-heading>A heading</sp-heading>
        <sp-divider size="large"></sp-divider>
        <sp-body>Hello!</sp-body>
        <footer>
            <sp-button>Close</sp-button>
        </footer>
    </form>
</dialog>
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`document.querySelector("dialog").uxpShowModal({size: {width: 480, height: 360}});
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      